import { all } from "redux-saga/effects";
import adminsaga from "./AdminList/adminsaga";
import SipPlanSaga from "./SipPlan/SipPlanSaga";
import JewellerSaga from "./JewellerList/JewellerSaga";
import storeSaga from "./StoreList/StoreSaga";
import { BlocklistSaga } from "./Blocklist/BlocklistSaga";
import { settingSaga } from "./sagas/settingSaga";
import { manageMetalsSaga } from "./sagas/manageMetalsSaga";
import { metalRateSaga } from "./sagas/manageMetalRateSaga";
import { CustomerSaga } from "./customer/CustomerSaga";
import carouselSaga from "./sagas/CarouselSaga";

import productListSaga from "./Product/ProductListSaga";
import bullionSaga from "./Bullion/BullionSaga";
import { OfferSaga } from "./Offers/OfferSaga";

import { watchOfflineTransactionSaga } from "./OfflineTransaction/OfflineTSaga";
import { watchGiftSaga } from "./Gifts/GiftsSaga";
import { metalsSaga } from "./GetMetals/metalSaga";
import { bullionDepositSaga } from "./BullionDeposit/bullionDepositSaga";
import { kycSaga } from "./Kyc/kycSaga";
import { appConfigSaga } from "./Configuration/configurationSaga";
import { watchSettingsSaga } from "./settings/settingsSaga";
import categorySaga from "./Product/ProductCategorySaga";
import { watchRedeemOrdersSaga } from "./Order/RedeemOrdersSaga";
import { watchSellOrdersSaga } from "./Order/SellOrdersSaga";
import { watchContentSaga } from "./Content/ContentSaga";
import { watchTransactionsSaga } from "./Transactions/TransactionsSaga";
import { dashboardSaga } from "./Dashboard/dashboardSaga";
import { watchSubscriptionPlanSaga } from "./sagas/Subscription/SubscriptionSaga";
import { watchJewellerReportSaga } from "./JewellerList/JewellerReportSaga";
import { watchCouponSaga } from "./sagas/Coupon/CouponSaga";

import { AppThemeSaga } from "./AppTheme/AppThemeSaga";
import requiredsaga from "./Required/requiredsaga";
import followUpSaga from "./FollowUp/followupSaga";
import { productOrdersSaga } from "./ProductOrder/productOrdersSaga";
import { referralSaga } from "./Referral/referralSaga";
import { metalRewardsSaga } from "./MetalRewards/metalRewardsSaga";
import  countrySaga from "./CountryList/CountrySaga";
import { genericWatcher } from "./Reports/reportsSaga";
import bookingBullionSaga from "./BookingBullion/bookingBullionSaga";
import { ticketSaga } from "./Tickets/ticketSaga";
import { trainingSaga } from "./Training/trainingSaga";
import { dashboardInfoSaga } from "./DashboardInfo/DashbaordInfoSaga";
import jewellerySaga from "./Jewellery/JewellerySaga";
import { jewellerDocumentSaga } from "./JewellerDocument/jewellerDocumentSaga";
import { customerCouponSaga } from "./CustomerCoupon/customerCouponSaga";
import { luckyDrawOptimSaga } from "./LuckyDrawOptim/luckyDrawOptimSaga";
import { luckyDrawBannerSaga } from "./LuckyDrawBanner/luckyDrawBannerSaga";
import { luckyDrawPopupSaga } from "./LuckyDrawPopup/luckyDrawPopupSaga";

// import requiredsaga from "./";

export default function* rootSaga() {
  yield all([
    adminsaga(),
    SipPlanSaga(),
    BlocklistSaga(),
    JewellerSaga(),
    storeSaga(),
    settingSaga(),
    manageMetalsSaga(),
    metalRateSaga(),
    CustomerSaga(),
    carouselSaga(),
    productListSaga(),
    bullionSaga(),
    OfferSaga(),
    watchSettingsSaga(),
    watchOfflineTransactionSaga(),
    watchGiftSaga(),
    metalsSaga(),
    bullionDepositSaga(),
    kycSaga(),
    appConfigSaga(),
    categorySaga(),
    watchRedeemOrdersSaga(),
    watchSellOrdersSaga(),
    watchContentSaga(),
    watchTransactionsSaga(),
    dashboardSaga(),
    watchSubscriptionPlanSaga(),
    AppThemeSaga(),
    watchJewellerReportSaga(),
    watchCouponSaga(),
    requiredsaga(),
        followUpSaga(),

    productOrdersSaga(),  referralSaga(),
    metalRewardsSaga(),
    countrySaga(),
    genericWatcher(),
    bookingBullionSaga(),
    ticketSaga(),
    trainingSaga(),
    dashboardInfoSaga(),
    jewellerySaga(),
    jewellerDocumentSaga(),
    customerCouponSaga(),
    luckyDrawOptimSaga(),
    luckyDrawBannerSaga(),
    luckyDrawPopupSaga(),
  ]);
}
